import * as React from 'react';

export function SvgMicrosoftTeamsLogo(props: any) {
  return (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>
      <path
        fill="#5059C9"
        d="M15.95 9.677h5.166c.488 0 .884.395.884.883v4.706a3.248 3.248 0 0 1-3.248 3.248h-.015a3.248 3.248 0 0 1-3.249-3.247v-5.128c0-.255.207-.462.462-.462ZM19.442 8.747a2.093 2.093 0 1 0 0-4.187 2.093 2.093 0 0 0 0 4.187Z"
      />
      <path
        fill="#7B83EB"
        d="M12.93 8.746a3.023 3.023 0 1 0 0-6.046 3.023 3.023 0 0 0 0 6.046ZM16.961 9.677H8.434a.874.874 0 0 0-.853.894v5.367a5.246 5.246 0 0 0 5.117 5.367 5.246 5.246 0 0 0 5.116-5.367v-5.367a.874.874 0 0 0-.853-.894Z"
      />
      <path
        fill="#000"
        d="M13.163 9.677v7.52a.856.856 0 0 1-.851.852H7.99a5.664 5.664 0 0 1-.41-2.112V10.57a.873.873 0 0 1 .852-.893h4.73Z"
        opacity=".1"
      />
      <path
        fill="#000"
        d="M12.698 9.677v7.986a.856.856 0 0 1-.851.851H8.209a6.04 6.04 0 0 1-.218-.465 5.664 5.664 0 0 1-.41-2.112V10.57a.873.873 0 0 1 .852-.893h4.265Z"
        opacity=".2"
      />
      <path
        fill="#000"
        d="M12.698 9.677v7.056a.858.858 0 0 1-.851.85h-4.02a5.664 5.664 0 0 1-.246-1.646V10.57a.873.873 0 0 1 .852-.893h4.265Z"
        opacity=".2"
      />
      <path
        fill="#000"
        d="M12.233 9.677v7.056a.858.858 0 0 1-.852.85H7.828a5.664 5.664 0 0 1-.247-1.646V10.57a.873.873 0 0 1 .852-.893h3.8Z"
        opacity=".2"
      />
      <path
        fill="#000"
        d="M13.163 7.272v1.465c-.08.005-.154.01-.233.01-.079 0-.153-.005-.232-.01a2.552 2.552 0 0 1-.465-.074A3.023 3.023 0 0 1 9.99 6.42h2.32c.47.002.85.382.852.851Z"
        opacity=".1"
      />
      <path
        fill="#000"
        d="M12.698 7.737v1a2.554 2.554 0 0 1-.466-.074 3.023 3.023 0 0 1-2.092-1.777h1.707c.469.002.849.382.85.851Z"
        opacity=".2"
      />
      <path
        fill="#000"
        d="M12.698 7.737v1a2.554 2.554 0 0 1-.466-.074 3.023 3.023 0 0 1-2.092-1.777h1.707c.469.002.849.382.85.851Z"
        opacity=".2"
      />
      <path
        fill="#000"
        d="M12.233 7.737v.926a3.023 3.023 0 0 1-2.094-1.777h1.242c.47.002.85.382.852.851Z"
        opacity=".2"
      />
      <path
        fill="url(#a)"
        d="M2.853 6.886h8.527c.47 0 .852.382.852.853v8.527c0 .47-.381.853-.852.853H2.853A.853.853 0 0 1 2 16.265V7.739c0-.471.382-.853.853-.853Z"
      />
      <path
        fill="#fff"
        d="M9.36 10.132H7.655v4.642H6.57v-4.642H4.873v-.9H9.36v.9Z"
      />
      <defs>
        <linearGradient
          id="a"
          x1="3.778"
          x2="10.455"
          y1="6.22"
          y2="17.785"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5A62C3" />
          <stop offset=".5" stopColor="#4D55BD" />
          <stop offset="1" stopColor="#3940AB" />
        </linearGradient>
      </defs>
    </svg>
  );
}
